import { createContext, useContext, useState, useEffect, useMemo, useCallback } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";

const SiteSettingsContext = createContext();

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const DEFAULTS = {
  firm_name: "PETROCONTROL",
  phone: "+52 (55) 1234-5678",
  email: "contacto@petrocontrol.mx",
  address_line1: "Av. Paseo de la Reforma 250, Piso 15",
  address_line2: "Ciudad de México, CDMX 06600",
  whatsapp: "+525512345678",
};

export function SiteSettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULTS);
  const { pathname } = useLocation();

  const fetchSettings = useCallback(() => {
    axios
      .get(`${API}/site-settings`)
      .then(({ data }) => {
        if (data && Object.keys(data).length > 0) setSettings(data);
      })
      .catch(() => {});
  }, [setSettings]);

  // Re-fetch whenever the user navigates (e.g. from /admin back to /)
  useEffect(() => {
    fetchSettings();
  }, [pathname, fetchSettings]);

  const value = useMemo(() => settings, [settings]);

  return (
    <SiteSettingsContext.Provider value={value}>
      {children}
    </SiteSettingsContext.Provider>
  );
}

export function useSiteSettings() {
  return useContext(SiteSettingsContext);
}
